import React from 'react';
import { ActivityIndicator } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { Colors } from '@shared/styles';
import { MBLoadingIndicatorProps } from '../props';

export function MBLoadingIndicator({
  color = Colors.v2.gray30,
  size = 'small',
  ...otherProps
}: MBLoadingIndicatorProps) {
  return (
    <MBView center {...otherProps}>
      <ActivityIndicator color={color} size={size} />
    </MBView>
  );
}
